module.exports = __webpack_public_path__ + "img/tabong_zakat.cbfdd5fa.png";